import moment from 'moment'

export const cpfCnpj = value => {
  const cpf = value =>
    (value || '').toString().replace(/([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/, '$1.$2.$3-$4')
  const cnpj = value =>
    (value || '')
      .toString()
      .replace(/([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})/, '$1.$2.$3/$4-$5')
  return (value || '').length <= 11 ? cpf(value) : cnpj(value)
}

export const date = date => moment(date).format('DD/MM/YYYY HH:mm')

export const round = (number, decimals = 1) => Number(number).toFixed(decimals)



// WEBPACK FOOTER //
// ./src/utils/format.js